class HomeController {
  /* @ngInject */
  constructor($window, $location, $stateParams, Session, urls, $http, $state) {
    this.$window = $window;
    this.$location = $location;
    this.Session = Session;
    this.$http = $http;
    this.urls = urls;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    const user = this.Session.read('userinfo');
    if (!user) {
      return this.$state.go('oauth.signin');
    }

    if (user && !user.email.includes(this.urls.GSUITE_DOMAIN)) {
      this.utmHistory();
    }

    // this.collectCoupon();

    // this.getMe();
    this.userSource = {};

    const { location } = this.$window;
    return this.clientRedirect();

  }

  getMe() {
    this
      .$http
      .get('/users/me')
      .then(() => {
        return this.clientRedirect();
      });

  }

  clientRedirect() {
    let { client_id: clientId } = this.$stateParams;
    const clientIdLocalStorage = this.$window.localStorage.client_id;
    if (clientIdLocalStorage) {
      return this.redirect(clientIdLocalStorage);
    }

    if ([undefined, 'undefined', null].includes(clientId)) {
      const user = this.Session.read('userinfo');
      if (user.email.includes('@shoppre.com')) {
        clientId = 'parcel-admin';
      } else if (user.suite_number) {
        clientId = 'sns';
      } else {
        clientId = 'parcel';
      }
    }
    if (!clientId) {
      this.getApps();
    }

    return this.redirect(clientId);
  }


  utmHistory() {
    const utmSource = this.getCookie('utm_source');
    const utmMedium = this.getCookie('utm_medium');
    const utmCampaign = this.getCookie('utm_campaign');
    const originalSource = this.getCookie('original_source');
    const parameterUrl = this.getCookie('parameter_url');
    const gclId = this.getCookie('gcl_id');
    const fromDomain = this.getCookie('from_domain');
    const referrer = this.getCookie('referrer');
    const firstVisit = this.getCookie('first_visit');
    const collectCoupon = this.getCookie('collect_coupon');

    const options = {
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      original_source: originalSource,
      parameter_url: parameterUrl,
      gcl_id: gclId,
      from_domain: fromDomain,
      referrer: referrer,
      first_visit: firstVisit,
      collect_coupon: collectCoupon,
    };
    const { LOGIN_APP } = this.urls;
    if (fromDomain) {
      const url = `${LOGIN_APP}/api/utmhistory`;
      this.$http.post(url, options);
    }
  }

  collectCoupon() {
    try {
      const user = this.Session.read('userinfo');
      const collectCoupon = this.getCookie('collect_coupon');

      if (collectCoupon && collectCoupon !== 'undefined') {
        const options = {
          user_id: user.id,
          coupon_code: collectCoupon,
          is_availed: false,
        };

        this.$http.post(`${this.urls.CAMPAIGN}/api/usercoupons`, options)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });

        document.cookie = 'collect_coupon' +`=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=.${document.domain.split('.').splice(1).join('.')}`;
      }
    } catch (error) {
      console.error(error);
    }
  }

  clearCookie() {
    const cookieList = ['utm_source', 'utm_medium', 'gcl_id', 'from_domain', 'post_login_page',
      'utm_campaign', 'original_source','parameter_url', 'referrer', 'first_visit', 'collect_coupon'];
    cookieList.map(x => {
      document.cookie = x +`=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=.${document.domain.split('.').splice(1).join('.')}`;
    });
  }

  redirect(clientId) {
    const { location } = this.$window;
    const { PREFIX, LOGIN_PARCELS_DOMAIN } = this.urls;
    return (location.href = this
      .href(clientId, `${PREFIX}${clientId.replace('-admin', '')}.${LOGIN_PARCELS_DOMAIN}`));
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  href(_clientId, baseUrl) {
    const user = this.Session.read('userinfo');
    const project = _clientId.replace('-admin', '');
    const clientId = ((user.email.includes(this.urls.GSUITE_DOMAIN) || user.group_id === 1) && (project !== 'psoms'))
      ? `${project}-admin`
      : project;
    const suffix = `${clientId.includes('-admin', '') ? 'admin/' : ''}access/oauth`;
    this.$window.localStorage.client_id = clientId;

    if (this.Session.read('member')) {
      const member = this.Session.read('member');
      if (this.Session.read('member')) {
        this.Session.remove('member');
      }
      return this.$location
        .path('/authorise')
        .search({
          membership_amount: member.amount,
          membership_type: member.type,
          client_id: clientId,
          response_type: 'code',
          redirect_uri: `${baseUrl}/${clientId === 'accounts' ? 'signin' : suffix}`,
        })
        .absUrl();
    } else {
      return this.$location
        .path('/authorise')
        .search({
          client_id: clientId,
          continue: this.$stateParams.continue,
          response_type: 'code',
          redirect_uri: `${baseUrl}/${clientId === 'accounts' ? 'signin' : suffix}`,
        })
        .absUrl();
    }
  }

  getApps() {
    return this.$http
      .get('/apps?domain_id=1')
      .then(({ data }) => {
        const fromDomain = this.getCookie('from_domain');
        this.clearCookie();
        this.APPS = data;
        if (fromDomain === 'shoppre.com' || fromDomain === 'shoppre.test') {
          this.redirect('parcel');
        }
        this.clearCookie();
      });
  }
}

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/home/home.controller.js